import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useRest } from "@karpeleslab/react-klbfw-hooks";

// component
import DisplayArticle from "components/Cms/DisplayArticle";
import NotFound from "components/NotFound/NotFound";

// constant

const Page = () => {
  const { slug } = useParams();
  const [notFound, setNotFound] = useState(false);

  // load
  const [article] = useRest(
    `Content/Cms/@page:loadSlug`,
    { slug: decodeURIComponent(slug) },
    true
  );

  useEffect(() => {
    if (article === false) {
      setNotFound(true);
    } else if (article !== null && article !== false) {
      setNotFound(false);
    }
  }, [article]);

  return (
    <>
      {!notFound && <DisplayArticle param={slug} article={article} />}
      {notFound && <NotFound backType="back" />}
    </>
  );
};

export default Page;
